import { hasScheduleStartDate } from "~/utils/program-schedule";

const COMMUNITY_EVENT_PATH_PREFIXES = ["/events", "/event-scanner"];
const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const DAYS_UNTIL_NPS_SURVEY = 14;

export interface NPSSurveyAgeCohort {
  enrolledAt?: string | null;
  metadata?: {
    startDate?: string | null;
  } | null;
}

export function shouldSuppressNPSSurveyForPath(pathname: string): boolean {
  const normalizedPath = pathname || "/";

  if (
    COMMUNITY_EVENT_PATH_PREFIXES.some(
      (prefix) =>
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`),
    )
  ) {
    return true;
  }

  return (
    normalizedPath.includes("/assessment") ||
    normalizedPath.includes("/programday_")
  );
}

export function getNPSSurveyAgeDate(
  cohort: NPSSurveyAgeCohort | null | undefined,
): string | null {
  if (hasScheduleStartDate(cohort?.metadata)) {
    return cohort.metadata.startDate;
  }

  return cohort?.enrolledAt ?? null;
}

export function hasReachedNPSSurveyAge(
  dateValue: Date | number | string | null | undefined,
  now = Date.now(),
): boolean {
  if (!dateValue) {
    return false;
  }

  const date =
    dateValue instanceof Date
      ? dateValue
      : typeof dateValue === "number"
        ? new Date(dateValue * 1000)
        : new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  return (
    Math.floor((now - date.getTime()) / MS_PER_DAY) >= DAYS_UNTIL_NPS_SURVEY
  );
}
